export const DOWNLOAD_DOCUMENT_ATTEMPT = 'DOWNLOAD_DOCUMENT_ATTEMPT';
export type DOWNLOAD_DOCUMENT_ATTEMPT = typeof DOWNLOAD_DOCUMENT_ATTEMPT;

export const DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS';
export type DOWNLOAD_DOCUMENT_SUCCESS = typeof DOWNLOAD_DOCUMENT_SUCCESS;

export const DOWNLOAD_DOCUMENT_FAILURE = 'DOWNLOAD_DOCUMENT_FAILURE';
export type DOWNLOAD_DOCUMENT_FAILURE = typeof DOWNLOAD_DOCUMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/download-document/Types.tsx